import './ImageAsset.scss';
import FileIcon from '../misc/FileIcon';
import FileSize from '../misc/FileSize';
import ImageResponsive from './ImageResponsive';
import PublishStatusDot from '../misc/PublishStatusDot';
import React from 'react';

class ImageAsset extends React.Component {
  render() {
    const asset = this.props.asset;
    const actions = [];

    if (this.props.onSelect) {
      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
          onClick={() => this.props.onSelect(asset)}
          title="Velg denne."
          key="select"
        >
          Velg
        </a>
      );
    }

    if (this.props.onEdit) {
      if (actions.length) {
        actions.push(<span key="space-1">&nbsp;</span>);
      }

      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-link`}
          onClick={() => this.props.onEdit(asset)}
          title="Endre tittel og beskrivelse."
          key="edit"
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
          {!this.props.compact &&
            <span> Endre</span>
          }
        </a>
      );
    }

    if (this.props.onRemove) {
      if (actions.length) {
        actions.push(<span key="space-2">&nbsp;</span>);
      }

      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-link`}
          onClick={() => this.props.onRemove(asset)}
          title="Fjern denne."
          key="remove"
        >
          <i className="fa fa-times" aria-hidden="true"></i>
          {!this.props.compact &&
            <span> Fjern</span>
          }
        </a>
      );
    }

    return (
      <div className="contentful-asset contentful-asset-image contentful-asset-toolbar-bottom">
        {asset.contentType.startsWith('video/') ?
          <video controls src={asset.url}></video> :
          <ImageResponsive
            className="img-rounded"
            src={asset.url}
            width={asset.details.image ? asset.details.image.width : 300}
            height={asset.details.image ? asset.details.image.height : 300}
            aspect={this.props.aspect}
          />}

        <div className="contentful-asset-toolbar contentful-asset-toolbar-inverse">
          <div className="contentful-asset-title" title={asset.description}>
            {!this.props.compact &&
              <FileIcon className="contentful-asset-icon" contentType={asset.contentType} />
            }
            <p>{asset.title}</p>
            <p>{asset.description ? `${asset.description.substring(0, 24)}...` : ''}</p>
            <p>{asset.details.image ? `${asset.details.image.width}x${asset.details.image.height}` : asset.fileName}&nbsp;&nbsp;<FileSize bytes={asset.details.size} />&nbsp;&nbsp;<PublishStatusDot entry={asset} /></p>
          </div>
          <div className="contentful-asset-actions">
            {actions}
          </div>
        </div>
      </div>
    );
  }
}

ImageAsset.defaultProps = {
  disabled: false,
  compact: false
};

export default ImageAsset;
